/**
 * Created by Andrey on 21.10.2026.
 */

// Impressions of our own ad of a type the limits forbid right now. The game offers an ad only when its limit is READY,
// so an impression of a running ad whose limit is DISABLED (the player's tier, an unsupported type) or UNAVAILABLE
// (not reached by progress) means the show was driven past the game's checks. The preroll is the exception: it goes out
// while unavailable (RewardedAdsManager.showInterstitial). An impression with the limit in order resets
class BlockedAdsFraud extends cleverapps.EventEmitter {
    constructor() {
        super();

        this.config = {
            threshold: 3
        };

        connector.ads.on("rewarded:impression", () => this.onImpression());
        connector.ads.on("interstitial:impression", () => this.onImpression());
    }

    onImpression() {
        const adLimit = cleverapps.rewardedAdsManager.getRunningAdLimit();
        if (!adLimit) {
            return;
        }

        this.trigger(this.isBlocked(adLimit) ? "hit" : "reset");
    }

    isBlocked(adLimit) {
        const state = cleverapps.adsLimits.state(adLimit);

        return state === AdsLimits.STATE_DISABLED
            || state === AdsLimits.STATE_UNAVAILABLE && adLimit !== AdsLimits.TYPES.PREROLL;
    }
}
